module.exports = __webpack_public_path__ + "static/media/014.82cbc9b7.jpg";